import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import FnrLoadingCarousel from "UI/FnrLoadingCarousel";

import { useGetBackgroundColorData } from "../../../API/queryHooks";

const PageLoadingOverlay = ({ isInitialLoad }) => {
  const { textColor } = useGetBackgroundColorData();

  return (
    <>
      {/* Initial page load overlay - covers entire page */}
      <LoadingOverlay $isLoading={isInitialLoad}>
        <FnrLoadingCarousel
          show={true}
          whiteBackground={false}
          color={textColor}
        />
      </LoadingOverlay>
    </>
  );
};

const LoadingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${({ $backgroundColor }) => $backgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  opacity: ${({ $isLoading }) => ($isLoading ? 1 : 0)};
  visibility: ${({ $isLoading }) => ($isLoading ? "visible" : "hidden")};
  transition: opacity 0.3s ease, visibility 0.3s ease;
`;

PageLoadingOverlay.propTypes = {
  isInitialLoad: PropTypes.bool,
};

export default PageLoadingOverlay;
